export const SocketConnected = 'Socket.Connected';
export interface SocketConnected {
	type: typeof SocketConnected;
}

export const SocketConnectionFailed = 'Socket.ConnectionFailed';
export interface SocketConnectionFailed {
	type: typeof SocketConnectionFailed;
	errorMessage: string;
}

export const CheckSocketHealth = 'Socket.CheckSocketHealth';
export interface CheckSocketHealth {
	type: typeof CheckSocketHealth;
}

export const BindAction = 'Front.Socket.BindAction';
export interface BindAction {
	type: typeof BindAction;
	actionName: string;
}

export const UnbindAction = 'Front.Socket.UnbindAction';
export interface UnbindAction {
	type: typeof UnbindAction;
	actionName: string;
}
